module.exports = __webpack_public_path__ + "assets/img/de-3079e567.png";